import { render, staticRenderFns } from "./IntegracionExpediente.vue?vue&type=template&id=32fa8a9a&scoped=true&"
import script from "./IntegracionExpediente.vue?vue&type=script&lang=js&"
export * from "./IntegracionExpediente.vue?vue&type=script&lang=js&"
import style0 from "./IntegracionExpediente.vue?vue&type=style&index=0&id=32fa8a9a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fa8a9a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
